let notificationInstance = null;

export const getNotificationInstance = () => {
  if (!notificationInstance)
    throw new Error("Notification instance not initialized");
  return notificationInstance;
};

export const setNotificationInstance = (instance) => {
  notificationInstance = instance;
};
